import { forwardRef, type InputHTMLAttributes, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/**
 * 入力欄（docs/09-design-system.md 第8章）。
 * 高さ 40px（PC）／44px（スマホ）、文字サイズ 16px で iOS の自動ズームを防ぐ。
 */
const fieldClass = cn(
  'w-full rounded-control border border-border bg-background text-input text-foreground',
  'placeholder:text-foreground-subtle',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-0',
  'disabled:bg-muted disabled:text-foreground-subtle disabled:cursor-not-allowed',
  'aria-[invalid=true]:border-2 aria-[invalid=true]:border-foreground',
);

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input ref={ref} className={cn(fieldClass, 'h-touch px-3 lg:h-10', className)} {...props} />
  ),
);
Input.displayName = 'Input';

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className, ...props }, ref) => (
    <textarea ref={ref} className={cn(fieldClass, 'min-h-24 px-3 py-2.5', className)} {...props} />
  ),
);
Textarea.displayName = 'Textarea';

export const Select = forwardRef<
  HTMLSelectElement,
  React.SelectHTMLAttributes<HTMLSelectElement>
>(({ className, ...props }, ref) => (
  <select ref={ref} className={cn(fieldClass, 'h-touch px-3 lg:h-10', className)} {...props} />
));
Select.displayName = 'Select';
